import { Fragment } from "react";

const RenderDocumentation = ({
  documentationContent,
  selectedSection,
  selectedRole,
}) => {
  // const section = documentationContent[selectedSection];
  const section = documentationContent?.filter(
    (section) =>
      section.role.find((role) => role === selectedRole) === selectedRole
  )[selectedSection];

  return (
    <div className="container mt-5 py-5 px-5">
      {section ? (
        <div>
          <h1>{section.section}</h1>
          {/* <div className="container my-4">
            {section?.headings?.map((heading, headingIndex) => (
              <Fragment key={headingIndex}>
                <h5
                  className="text-primary"
                  style={headingStyle}
                  onClick={() =>
                    handleScroll(
                      `${section.section.split(" ")[0]}-${
                        heading.heading.split(" ")[0]
                      }`
                    )
                  }
                >
                  {heading?.heading}
                </h5>
                <div className="mb-3">
                  {heading?.subHeadings?.length > 1 &&
                    heading?.subHeadings?.map((subHeading, subHeadingIndex) => (
                      <h5
                        key={subHeadingIndex}
                        className="ms-3 text-primary"
                        style={headingStyle}
                        onClick={() =>
                          handleScroll(
                            `${section.section.split(" ")[0]}-${
                              subHeading.subHeading.split(" ")[0]
                            }`
                          )
                        }
                      >
                        {subHeading.subHeading}
                      </h5>
                    ))}
                </div>
              </Fragment>
            ))}
          </div> */}
          {section?.headings?.map((heading, headingIndex) => (
            <section
              key={headingIndex}
              // id={`${section.section.split(" ")[0]}-${
              //   heading.heading.split(" ")[0]
              // }`}
            >
              <h2
                className="mt-5 observe-documentation"
                // id={`${section.section.split(" ")[0]}-${
                //   heading.heading.split(" ")[0]
                // }`}
                id={heading.id}
              >
                {heading?.heading}
              </h2>
              {heading?.content?.map((content, contentIndex) => (
                <p key={contentIndex} className="mt-3">
                  {content}
                </p>
              ))}
              {heading?.subHeadings?.map((subHeading, subHeadingIndex) => (
                <section
                  key={subHeadingIndex}
                  className="mt-4 observe-documentation"
                  // id={`${section.section.split(" ")[0]}-${
                  //   subHeading.subHeading.split(" ")[0]
                  // }`}
                  id={subHeading.id}
                >
                  <h2 className="mt-5">{subHeading.heading}</h2>
                  <h4
                    className="mt-4"
                    // id={`${section.section.split(" ")[0]}-${
                    //   subHeading.subHeading.split(" ")[0]
                    // }`}
                  >
                    {subHeading.subHeading}
                  </h4>
                  {/* <hr /> */}
                  {subHeading?.qa?.map((qa, qaIndex) => (
                    <div key={qaIndex} className="card mt-4 p-5">
                      <div className="card-body">
                        <p>
                          <strong>Q:</strong> {qa.question}
                        </p>
                        <p>
                          <strong>A:</strong>
                        </p>
                        <ol>
                          {qa?.answer.map((answer, answerIndex) =>
                            qa.answer.length === 1 ? (
                              <p key={answerIndex}>{answer}</p>
                            ) : (
                              <li key={answerIndex}>
                                {answer}
                                {typeof qa?.image?.[answerIndex] ===
                                  "object" && (
                                  <div
                                    // key={i}
                                    className="d-flex align-items-center"
                                  >
                                    <img
                                      src={qa.image[answerIndex][answerIndex]}
                                      alt="Login Steps"
                                      className="img-fluid mx-auto"
                                    />
                                  </div>
                                )}
                              </li>
                            )
                          )}
                        </ol>
                        {typeof qa?.image?.[0] !== "object" &&
                          qa?.image?.map((img, i) => (
                            <div key={i} className="d-flex align-items-center">
                              <img
                                src={img}
                                alt="Login Steps"
                                className="img-fluid mx-auto"
                              />
                            </div>
                          ))}
                      </div>
                    </div>
                  ))}
                  {subHeading?.content?.length && (
                    <ol>
                      {subHeading?.content?.map((answer, answerIndex) =>
                        subHeading.content.length === 1 ? (
                          <p key={answerIndex}>{answer}</p>
                        ) : (
                          <li key={answerIndex}>
                            {answer}
                            {typeof subHeading?.image?.[answerIndex] ===
                              "object" &&
                              subHeading?.multipleCase && (
                                <div
                                  // key={i}
                                  className="d-flex align-items-center"
                                >
                                  <img
                                    src={
                                      subHeading?.image[answerIndex][
                                        answerIndex
                                      ]
                                    }
                                    alt="Login Steps"
                                    className="img-fluid mx-auto"
                                  />
                                </div>
                              )}
                          </li>
                        )
                      )}
                    </ol>
                  )}
                  {subHeading?.outerli?.map((answer, answerIndex) => (
                    <>
                      {subHeading?.outerli?.length === 1 ||
                      subHeading?.showLiAsP ? (
                        <p>{answer}</p>
                      ) : (
                        <>
                          <li className="ms-5" key={answerIndex}>
                            {answer}
                          </li>
                          {subHeading?.middleNote?.length &&
                            subHeading?.middleNote?.map((note) => {
                              if (note.index === answerIndex) {
                                return <p>{note?.text}</p>
                              }
                            })}
                        </>
                      )}
                      {subHeading?.innerli?.[answerIndex]?.content?.length && (
                        <ul className="ms-5">
                          {subHeading?.innerli?.[answerIndex]?.content?.map(
                            (li, indexli) => (
                              <li key={indexli}>{li}</li>
                            )
                          )}
                        </ul>
                      )}
                    </>
                  ))}
                  {!subHeading?.multipleCase &&
                    subHeading?.image?.map((img, i) => (
                      <div key={i} className="d-flex align-items-center">
                        <img
                          src={img}
                          alt="Login Steps"
                          className="img-fluid mx-auto"
                        />
                      </div>
                    ))}

                  {subHeading?.threeLayers &&
                    subHeading?.layerType === "not-ordered" &&
                    subHeading?.mainContent?.map((el, idx) => (
                      <>
                        <p key={idx}>{el}</p>
                        {subHeading?.secondLayer?.map((answer, answerIndex) => {
                          if (answer?.index == idx) {
                            return (
                              <>
                                {answer?.content?.length === 1 &&
                                subHeading?.showLiAsP ? (
                                  <p>{answer}</p>
                                ) : (
                                  <>
                                    {answer?.content?.map((text, idx2) => (
                                      <Fragment key={idx2}>
                                        <li className="ms-5">{text}</li>
                                        {subHeading?.middleNote?.length &&
                                          subHeading?.middleNote?.map(
                                            (note) => {
                                              if (note.index === answerIndex) {
                                                return <p>{note?.text}</p>;
                                              }
                                            }
                                          )}
                                        {answer?.innerli?.map((el2, idx3) => {
                                          if (el2?.index == idx2) {
                                            return (
                                              <ul className="ms-5">
                                                {el2?.content?.map(
                                                  (li, indexli) => (
                                                    <li key={indexli}>{li}</li>
                                                  )
                                                )}
                                              </ul>
                                            );
                                          }
                                        })}
                                      </Fragment>
                                    ))}
                                  </>
                                )}
                              </>
                            );
                          }
                        })}
                        {subHeading?.mainContentImage?.map((item) => {
                          if (item?.index == idx) {
                            return item?.image?.map((img, idx5) => (
                              <div
                                key={idx5}
                                className="d-flex align-items-center"
                              >
                                <img
                                  src={img}
                                  alt="Login Steps"
                                  className="img-fluid mx-auto"
                                />
                              </div>
                            ));
                          }
                        })}
                        {subHeading?.extraNote?.map((note) => {
                          if (note.index == idx) {
                            return (
                              <div className={`${note?.className}`}>
                                <p className="fw-bold">{note?.title}</p>
                                {note?.content?.map((text, idx) => (
                                  <p key={idx}>{text}</p>
                                ))}
                              </div>
                            );
                          }
                        })}
                      </>
                    ))}
                </section>
              ))}
            </section>
          ))}
        </div>
      ) : (
        <div>Please select a section from the sidebar.</div>
      )}
    </div>
  );
};

export default RenderDocumentation;
